import React, { Component } from "react";
import Routes from "./routes/mainRoutes";
import { HashRouter } from "react-router-dom";
import { socket, EVENTS } from './providers/config';
import "./App.css";

class App extends Component {

  componentDidMount() {
    setInterval(() => socket.emit(EVENTS.SEND_PING), 1000);
  }

  render() {
    return (
      <HashRouter>
        <Routes />
      </HashRouter>
    );
  }
}
export default App;
